(() => {
  if (window.VzyHome) {
    window.VzyHome.init();
    return;
  }

  const runtime = { controller: null, version: '2.0.0' };

  const dispatchInteraction = (detail = {}) => {
    document.dispatchEvent(
      new CustomEvent('vzy:home:interaction', {
        detail: {
          event: detail.event || 'interaction',
          sectionId: detail.sectionId || '',
          productId: detail.productId || '',
          handle: detail.handle || '',
          position: Number(detail.position || 0),
          source: detail.source || 'homepage',
          version: runtime.version,
        },
      }),
    );
  };

  const getSelectedValue = (selector, groupName) =>
    selector.querySelector(
      `[data-vzy-selector-group="${groupName}"] [data-vzy-selector-option][aria-pressed="true"]`,
    )?.dataset.vzySelectorValue || '';

  const initSelector = (selector, signal) => {
    if (!selector || selector.dataset.vzySelectorReady === 'true') return;

    const groups = Array.from(selector.querySelectorAll('[data-vzy-selector-group]'));
    const submit = selector.parentElement?.querySelector('[data-vzy-selector-submit]');
    const status = selector.parentElement?.querySelector('[data-vzy-selector-status]');
    if (!groups.length || !submit || !status) return;

    selector.dataset.vzySelectorReady = 'true';

    const updateResult = () => {
      const connection = getSelectedValue(selector, 'connection');
      const chosenLabels = groups
        .map((group) => group.querySelector('[data-vzy-selector-option][aria-pressed="true"]')?.textContent?.trim())
        .filter(Boolean);

      submit.disabled = !connection;
      status.textContent = connection
        ? `Selecție: ${chosenLabels.join(' · ')}. Îți arătăm categoria cea mai apropiată.`
        : 'Alege cel puțin tipul de conexiune.';
    };

    groups.forEach((group) => {
      const options = Array.from(group.querySelectorAll('[data-vzy-selector-option]'));
      options.forEach((option) => {
        option.setAttribute('role', 'button');
        option.setAttribute('aria-pressed', 'false');
        option.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== ' ') return;
            event.preventDefault();
            option.click();
          },
          { signal },
        );
        option.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            options.forEach((candidate) => {
              candidate.setAttribute('aria-pressed', String(candidate === option));
            });
            updateResult();
            dispatchInteraction({
              event: 'selector_option',
              sectionId: selector.closest('.shopify-section')?.id || '',
              source: option.dataset.vzySelectorValue || 'selector',
            });
          },
          { signal },
        );
      });
    });

    submit.addEventListener(
      'click',
      () => {
        const connection = getSelectedValue(selector, 'connection');
        const power = getSelectedValue(selector, 'power');
        const placement = getSelectedValue(selector, 'placement');
        const feature = getSelectedValue(selector, 'function');
        if (!connection) return;

        if (connection === 'wifi' && power === 'solar') {
          dispatchInteraction({
            event: 'selector_result',
            sectionId: selector.closest('.shopify-section')?.id || '',
            source: 'solar-wifi',
          });
          window.location.assign('/collections/camere-solare-wifi-vizzyo');
          return;
        }

        let slug = 'wifi';
        if (connection === '4g' || power === 'solar') slug = feature === 'zoom' ? 'solar-zoom' : '4g';
        else if (placement === 'indoor') slug = 'interior';
        else if (feature === 'zoom') slug = 'wifi-zoom';

        document.dispatchEvent(new CustomEvent('vzy:home:select-band', { detail: { slug } }));
        dispatchInteraction({
          event: 'selector_result',
          sectionId: selector.closest('.shopify-section')?.id || '',
          source: slug,
        });
      },
      { signal },
    );

    updateResult();
  };

  const init = () => {
    if (runtime.controller && !runtime.controller.signal.aborted) return;

    runtime.controller = new AbortController();
    const { signal } = runtime.controller;

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest('[data-vzy-event]');
        if (trigger) {
          dispatchInteraction({
            event: trigger.dataset.vzyEvent,
            sectionId: trigger.dataset.vzySectionId,
            productId: trigger.dataset.vzyProductId,
            handle: trigger.dataset.vzyHandle,
            position: trigger.dataset.vzyPosition,
            source: trigger.dataset.vzySource,
          });
        }

        const productCta = event.target.closest('.vzy-collection-bands--home [data-vzy-card-cta]');
        if (productCta) {
          const card = productCta.closest('[data-vzy-card]');
          const item = productCta.closest('[data-vzy-band-item]');
          dispatchInteraction({
            event: 'product',
            sectionId: productCta.closest('[data-section-id]')?.dataset.sectionId || '',
            productId: card?.dataset.vzyProductId || '',
            handle: card?.dataset.vzyProductHandle || '',
            position: item?.dataset.vzyOriginalIndex || 0,
            source: 'home-catalog',
          });
        }

        const hashLink = event.target.closest('a[href^="#"]');
        if (!hashLink) return;
        const target = document.getElementById(hashLink.hash.slice(1));
        if (!target) return;
        window.setTimeout(() => target.focus({ preventScroll: true }), 0);
      },
      { signal },
    );

    document.addEventListener(
      'play',
      (event) => {
        const video = event.target.closest('[data-vzy-home-video]');
        if (!video) return;
        dispatchInteraction({ event: 'video', source: video.dataset.vzySource || 'home-media' });
      },
      { capture: true, signal },
    );

    document.querySelectorAll('[data-vzy-smart-selector]').forEach((selector) => initSelector(selector, signal));
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        if (event.target.matches?.('[data-vzy-smart-selector]')) initSelector(event.target, signal);
        event.target.querySelectorAll?.('[data-vzy-smart-selector]').forEach((selector) => initSelector(selector, signal));
      },
      { signal },
    );
  };

  const destroy = () => {
    runtime.controller?.abort();
    runtime.controller = null;
    document.querySelectorAll('[data-vzy-smart-selector]').forEach((selector) => {
      delete selector.dataset.vzySelectorReady;
    });
  };

  window.addEventListener('pageshow', init);
  window.addEventListener('pagehide', destroy);
  window.VzyHome = { init, destroy, version: runtime.version };
  init();
})();

